import { getMailtoHref, openMailto } from '../../utils/contactLinks'

function EmailLink({ email, className = '', children, ...props }) {
  const address = String(email || (typeof children === 'string' ? children : '') || '').trim()
  const href = getMailtoHref(address)

  if (!href) {
    return <span className={className}>{children}</span>
  }

  return (
    <a
      href={href}
      className={className}
      onClick={(event) => openMailto(address, event)}
      {...props}
    >
      {children ?? address}
    </a>
  )
}

export default EmailLink
